import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function AuthCallback() {
  const navigate = useNavigate()
  const location = useLocation()
  const { checkAuthState } = useAuth()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Check if there's an authorization code in the URL
        const urlParams = new URLSearchParams(location.search)
        const code = urlParams.get('code')
        const error = urlParams.get('error')

        if (error) {
          console.error('OAuth error:', error)
          navigate('/login', { 
            state: { 
              error: 'Authentication failed. Please try again.' 
            } 
          })
          return
        }

        if (code) {
          // Let Amplify handle the OAuth callback
          await checkAuthState()
          
          // Redirect to the original destination or home
          const from = location.state?.from?.pathname || '/'
          navigate(from, { replace: true })
        } else {
          // No code, redirect to login
          navigate('/login')
        }
      } catch (error) {
        console.error('Callback handling error:', error)
        navigate('/login', { 
          state: { 
            error: 'Authentication failed. Please try again.' 
          } 
        })
      }
    }

    handleCallback()
  }, [location, navigate, checkAuthState])

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Signing you in...</h1>
          <p>Please wait while we complete your authentication</p>
        </div>
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  )
}

export default AuthCallback